import React from 'react';
import Header from '../components/Header';
import CustomFooter from '../components/Footer';
import ViewProfilesTable from '../ui/ViewProfilesTable';

const ViewProfiles= () => {
    return (
        <div className="bg-gray-100 min-h-screen flex flex-col">
            <Header />
            <div className="flex-grow">
                <ViewProfilesTable />                          
            </div>
            <CustomFooter />
        </div>
    );
};

export default ViewProfiles;